<div class="content-body">
    <app-breadcrumb [breadcrumb]="breadcrumbList" [addProperty]="checkAddInspection ? 'Back' : ''" (addEvent)="backToInspections($event)"> </app-breadcrumb>
    <div class="container-fluid">
        <div class="row">
            <!-- Download & Share Actions -->
            <div class="col-xl-12 mb-2" *ngIf="checkDownloadPermission">
                <div class="d-flex justify-content-end gap-2">
                    <button class="btn btn-primary btn-sm" (click)="downloadPdf()" [disabled]="isDownloading">
                        <i class="fa fa-download me-1"></i>
                        <span *ngIf="!isDownloading || activeDownloadType !== 'download'">Download PDF</span>
                        <span *ngIf="isDownloading && activeDownloadType === 'download'">{{ downloadProgress }}</span>
                    </button>
                    <button class="btn btn-outline-info btn-sm" (click)="openShareModal('email')" [disabled]="isDownloading">
                        <i class="fa fa-envelope me-1"></i>
                        <span *ngIf="!isDownloading || activeDownloadType !== 'email'">Share via Email</span>
                        <span *ngIf="isDownloading && activeDownloadType === 'email'">{{ downloadProgress }}</span>
                    </button>
                    <button class="btn btn-outline-success btn-sm" (click)="openShareModal('whatsapp')" [disabled]="isDownloading">
                        <i class="fa fa-whatsapp me-1"></i>
                        <span *ngIf="!isDownloading || activeDownloadType !== 'whatsapp'">Share via WhatsApp</span>
                        <span *ngIf="isDownloading && activeDownloadType === 'whatsapp'">{{ downloadProgress }}</span>
                    </button>
                </div>
            </div>

            <div class="col-xl-4">
                <div class="card">
                    <div class="card-header border-0">
                        <h6 class="card-title">Villa/Flat No: <span class="property-notes">{{propertyDetails?.name}}</span></h6>
                    </div>
                </div>
            </div>
            <div class="col-xl-4">
                <div class="card">
                    <div class="card-header border-0">
                        <h6 class="card-title">Location: <span class="property-notes">{{propertyDetails?.locality}} {{propertyDetails?.address_1 }} {{propertyDetails?.address_2 }}</span></h6>
                    </div>
                </div>
            </div>
            <div class="col-xl-4">
                <div class="card">
                    <div class="card-header border-0">
                        <h6 class="card-title">Current Status: <span class="property-notes">{{inspectionDetails?.inspection_status}}</span></h6>
                    </div>
                </div>
            </div>
            <!--Summary-->
            <div class="col-xl-12">
                <div class="card">
                    <div class="card-header border-0">
                        <h6 class="card-title">Summary: <span class="property-notes">{{inspectionDetails?.inspection_notes}}</span></h6>
                    </div>
                </div>
            </div>
            <div class="col-xl-12 mb-1" *ngIf="inspectionDetails?.uploads?.length">
                <div class="card">
                    <div class="card-header border-0 mb-0">
                        <h6 class="property-notes">Inspection Images</h6>
                    </div>
                    <div class="card-body pt-0">
                        <div *ngFor="let img of inspectionDetails.uploads; let i = index">
                            <div class="row">
                                <div class="col-md-9">
                                    <p class="badge light badge-light"> {{ img.original_name }} </p>
                                </div>
                                <div class="col-md-3">
                                    <p class="badge light badge-primary me-3 ms-3 c-pointer" (click)="viewImage(img.url)"> View </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--List of inspections-->
            <div class="col-lg-12">
                <div ngbAccordion *ngFor="let inspections of inspectionsList; let i = index" id="room-{{ i }}">
                    <div ngbAccordionItem #item="ngbAccordionItem" [collapsed]="false" class="item">
                        <h2 ngbAccordionHeader [ngClass]="{'accordion-header accordion-header-primary': true}" class="room-inspections">
                            <button ngbAccordionButton class="accordion-header rounded-lg">
                                {{inspections.room_name}}
                            </button>
                        </h2>
                        <div ngbAccordionCollapse>
                            <div ngbAccordionBody>
                                <ng-template>
                                    <div class="table-responsive">
                                        <table class="table table-responsive-md inspection-table">
                                            <thead>
                                                <tr>
                                                    <th>ITEM</th>
                                                    <th class="col-quantity">QUANTITY</th>
                                                    <th class="col-condition">CONDITION</th>
                                                    <th class="col-notes">NOTES</th>
                                                    <th class="col-images">Images</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let inspection of inspections.room_items">
                                                    <td>{{inspection.item_name}}</td>
                                                    <td class="col-quantity">{{inspection.item_quantity}}</td>
                                                    <td class="col-condition">{{inspection.item_condition}}</td>
                                                    <td class="col-notes">{{inspection.item_notes}}</td>
                                                    <td class="col-images">
                                                        <i class="fa fa-eye mt-3 c-pointer" *ngIf="inspection?.item_uploads?.length" (click)="viewPropertyImage(viewImagecontent, inspection?.item_uploads)"></i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Checkbox -->
            <form *ngIf="inspectionDetails?.showSubmit" (ngSubmit)="onSubmit()">
                <div class="col-lg-12 d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                        <input type="checkbox" name="acceptTerms" [(ngModel)]="acceptTerms" class="form-check-input me-2" />
                    </div>

                    <div class="flex-grow-1 ms-1 mt-2">
                        <h6 class="mt-1"><span class="property-notes">I confirm that I accept the above information and that all
                                details provided are correct.</span></h6>
                    </div>

                    <div>
                        <button class="btn btn-primary ms-1 me-3" type="submit"
                            [disabled]="!acceptTerms || loadingService.isLoading()">Submit</button>
                    </div>
                </div>
            </form>

        </div>
    </div>
</div>


<ng-template #viewImagecontent let-modal>
    <div class="modal-header">
        <h5 class="modal-title"> Inspection Images </h5>
        <button type="button" class="btn-close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body">
        <ngb-carousel class="fixed-height-carousel" [showNavigationIndicators]="false">

            <ng-template ngbSlide *ngFor="let image of inspectionImages">
                <div class="picsum-img-wrapper position-relative">
                    <img [src]="image.url" alt="" class="d-block w-100" />
                    <div class="gps-overlay" *ngIf="checkLocationView && image?.latitude && image?.longitude">
                        <div class="gps-overlay__map">
                            <img *ngIf="image.map_image_url" [src]="image.map_image_url" alt="Satellite location" />
                            <span class="gps-overlay__pin"></span>
                        </div>
                        <div class="gps-overlay__info">
                            <div class="gps-overlay__address" *ngIf="image.address">{{ image.address }}</div>
                            <div class="gps-overlay__line">Lat: {{ image.latitude }}&nbsp;&nbsp;Long: {{ image.longitude }}</div>
                            <div class="gps-overlay__line" *ngIf="image.captured_at">{{ image.captured_at | date:'dd/MM/yyyy hh:mm a' }}</div>
                        </div>
                    </div>
                </div>
            </ng-template>

        </ngb-carousel>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">Close</button>
    </div>
</ng-template>

<!-- Share Modal -->
<div class="modal fade" [class.show]="showShareModal" [style.display]="showShareModal ? 'block' : 'none'" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">
                    {{ shareType === 'email' ? 'Share via Email' : 'Share via WhatsApp' }}
                </h5>
                <button type="button" class="btn-close" (click)="closeShareModal()"></button>
            </div>
            <div class="modal-body">
                <form [formGroup]="shareForm">
                    <div class="row mb-3">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="form-label">First Name</label>
                                <input type="text" class="form-control" formControlName="first_name" placeholder="Enter first name">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="form-label">Last Name</label>
                                <input type="text" class="form-control" formControlName="last_name" placeholder="Enter last name">
                            </div>
                        </div>
                    </div>
                    <div class="form-group mb-3" *ngIf="shareType === 'email'">
                        <label class="form-label">Email Address</label>
                        <input type="email" class="form-control" formControlName="email" placeholder="Enter email address">
                    </div>
                    <div class="row" *ngIf="shareType === 'whatsapp'">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="form-label">Country Code</label>
                                <input type="text" class="form-control" formControlName="country_code" placeholder="+91">
                            </div>
                        </div>
                        <div class="col-md-8">
                            <div class="form-group">
                                <label class="form-label">WhatsApp Number</label>
                                <input type="text" class="form-control" formControlName="whatsapp" placeholder="Enter phone number">
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="closeShareModal()">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="submitShare()">
                    {{ shareType === 'email' ? 'Send Email' : 'Send WhatsApp' }}
                </button>
            </div>
        </div>
    </div>
</div>
<div class="modal-backdrop fade" [class.show]="showShareModal" *ngIf="showShareModal"></div>
